var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ev-autocomplete',_vm._b({attrs:{"items":_vm.levels,"label":"Уровень","item-text":"name","item-value":"value"},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}},'ev-autocomplete',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }